export default {
    fonts: {
        body: 'Lato, Helvetica, Arial, sans-serif',
    },
    fontSizes: {
        xs: '0.875rem',
        sm: '0.925rem',
        md: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.75rem',
        '7xl': '4.5rem',
        '8xl': '6rem',
        '9xl': '8rem',
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        extralite: 200,
        light: 300,
        normal: 400,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900,
    },
    lineHeights: {
        normal: 'normal',
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: '2',
        '3': '.75rem',
        '4': '1rem',
        '5': '1.25rem',
        '6': '1.5rem',
        '7': '1.75rem',
        '8': '2rem',
        '9': '2.25rem',
        '10': '2.5rem',
    },
    letterSpacings: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em',
    },
    textStyles: {
        h1: {
            fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            fontSize: '2rem',
            fontWeight: 'semibold',
            lineHeight: '34px',
            color: 'black',
        },
        h2: {
            fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            fontSize: '2rem',
            fontWeight: 'light',
            lineHeight: '34px',
            color: 'gray.700',
        },
        h3: {
            fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            fontSize: '1.5rem',
            fontWeight: 'semibold',
            lineHeight: '22px',
            color: 'black',
        },
        h4: {
            fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            fontSize: '1.5rem',
            fontWeight: 'light',
            lineHeight: '22px',
            color: 'gray.700',
        },
        h5: {
            fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            fontSize: '1.25rem',
            fontWeight: 'semibold',
            lineHeight: '21px',
            color: 'black',
        },
        h6: {
            fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            fontSize: '1.25rem',
            fontWeight: 'light',
            lineHeight: '21px',
            color: 'gray.700',
        },
        lead: {
            fontSize: '1.125rem',
            fontWeight: 'light',
            lineHeight: '18px',
            color: 'gray.700',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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